import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Form from 'carbon-react/lib/components/form';
import Button from 'carbon-react/lib/components/button';
import { Sidebar } from '@futrli/ui-components';
import Typography from 'carbon-react/lib/components/typography';

import { useConsolidationContext } from '../../../consolidation-context/consolidation-context';

import styles from './modal.scss';
import { OffsetEliminationsForm } from './offset-eliminations-form/offset-eliminations-form';

export const OffsetEliminationsGroupSidebar = () => {
  const {
    eliminations: { eliminationsForm, handleCloseEliminationsModal, handleSaveEliminationGroup, showEliminationsModal }
  } = useConsolidationContext();

  const intl = useIntl();

  return (
    <Sidebar
      open={showEliminationsModal}
      onCancel={handleCloseEliminationsModal}
      header={
        <Typography variant="h2" fontWeight="700">
          {intl.formatMessage({
            id: 'consolidation.choose_account_category',
            defaultMessage: 'Choose account category'
          })}
        </Typography>
      }
    >
      <Form
        stickyFooter
        leftSideButtons={
          <Button onClick={handleCloseEliminationsModal} buttonType="secondary">
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
        }
        saveButton={
          <Button
            onClick={handleSaveEliminationGroup}
            disabled={!eliminationsForm.formState.isValid}
            buttonType="primary"
          >
            <FormattedMessage id="common.save" defaultMessage="Save" />
          </Button>
        }
        onSubmit={e => e.preventDefault()}
      >
        <p className={styles.text}>
          <FormattedMessage
            id="consolidation.offset_eliminations_group_desc"
            defaultMessage="Offset elimination groups need to appear in a category within your chart of accounts to ensure data balances."
          />
        </p>
        <OffsetEliminationsForm />
      </Form>
    </Sidebar>
  );
};
